/**
 * Unified History Page
 * 
 * * Combines operator action history and parsing history in one page with tabs
 */

import { useSearchParams } from 'react-router-dom'
import { Tabs, Typography } from 'antd'
import { HistoryOutlined, RocketOutlined } from '@ant-design/icons'
import HistoryPage from './HistoryPage'
import ParsingHistoryPage from './ParsingHistoryPage'

const { Title } = Typography

function UnifiedHistoryPage() {
  const [searchParams, setSearchParams] = useSearchParams()
  
  // * Get active sub-tab from URL or default to 'actions'
  const activeSubTab = searchParams.get('view') || 'actions'

  const handleTabChange = (key: string) => {
    setSearchParams({ view: key })
  }

  const tabItems = [
    {
      key: 'actions',
      label: (
        <span style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: '15px' }}>
          <HistoryOutlined style={{ fontSize: '18px' }} />
          <span>Действия операторов</span>
        </span>
      ),
      children: <HistoryPage />,
    },
    {
      key: 'parsing',
      label: (
        <span style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: '15px' }}>
          <RocketOutlined style={{ fontSize: '18px' }} />
          <span>Парсинг Yandex</span>
        </span>
      ),
      children: <ParsingHistoryPage />,
    },
  ]

  return (
    <div style={{ padding: '0' }}>
      <Title level={2} style={{ marginBottom: 24 }}>
        История
      </Title>

      <Tabs
        activeKey={activeSubTab}
        onChange={handleTabChange}
        items={tabItems}
        size="large"
        tabBarStyle={{
          marginBottom: 24,
          paddingBottom: 12,
          borderBottom: '2px solid #e8e8e8',
        }}
      />
    </div>
  )
}

export default UnifiedHistoryPage

